var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8778_13156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5508 22.73L3.5908 2.77002L2.8208 2.00002L2.0908 1.27002L0.820801 2.54002L5.2108 6.93002L7.4208 11.59L6.0708 14.04C5.9108 14.32 5.8208 14.65 5.8208 15C5.8208 16.1 6.7208 17 7.8208 17L15.2808 17L16.6608 18.38C16.3174 18.6262 16.061 18.9749 15.9283 19.3761C15.7957 19.7772 15.7937 20.2101 15.9226 20.6124C16.0515 21.0148 16.3048 21.3659 16.6458 21.6152C16.9869 21.8645 17.3983 21.9993 17.8208 22C18.4908 22 19.0808 21.67 19.4408 21.16L22.2808 24L23.5508 22.73ZM8.2408 15C8.1008 15 7.9908 14.89 7.9908 14.75L8.0208 14.63L8.9208 13L11.2808 13L13.2808 15L8.2408 15ZM16.3708 13C17.1208 13 17.7808 12.59 18.1208 11.97L21.7008 5.48002C21.7833 5.32741 21.8248 5.156 21.8213 4.98255C21.8177 4.8091 21.7693 4.63953 21.6806 4.49041C21.5919 4.34129 21.4661 4.21772 21.3154 4.13176C21.1647 4.04581 20.9943 4.00042 20.8208 4.00002L7.3608 4.00002L16.3708 13ZM7.8208 18C6.7208 18 5.8308 18.9 5.8308 20C5.8308 21.1 6.7208 22 7.8208 22C8.9208 22 9.8208 21.1 9.8208 20C9.8208 18.9 8.9208 18 7.8208 18Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8778_13156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.820801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCart);
export default __webpack_public_path__ + "static/media/noCart.99cd3ffca39472e0a6af6d79a7c20abd.svg";
export { ForwardRef as ReactComponent };